import { getStoredToken } from '../utils/authSync';
import { parseDp } from './deepLinks';

const listeners = new Map();

function emit(name, payload) {
  const set = listeners.get(name);
  if (!set) return;
  for (const fn of set) {
    try { fn(payload); } catch { /* ignore */ }
  }
}

async function http(path, opts = {}) {
  const token = getStoredToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`/api/wowsmart${path}`, {
    method: opts.method || 'GET',
    headers,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || 'Hazine hata');
    err.status = res.status;
    err.code = data.code;
    err.err_code = data.err_code;
    throw err;
  }
  return data;
}

const api = {
  getUserProfile: () => http('/profile'),
  getLevels: () => http('/levels').then((d) => d.levels || []),
  getCurrentLevel: async () => {
    const p = await http('/profile');
    return p.level;
  },
  getMissions: () => http('/missions').then((d) => d.missions || []),
  requestMissionOptIn: (id) => http(`/missions/${id}/opt-in`, { method: 'POST' }),
  requestMissionClaimReward: (id) => http(`/missions/${id}/claim`, { method: 'POST' }),
  getLeaderBoard: (periodType = 'weekly', previous = false) =>
    http(`/leaderboard?type=${encodeURIComponent(periodType)}${previous ? '&previous=1' : ''}`),
  getLeaderBoards: () => http('/leaderboards').then((d) => d.leaderboards || []),
  getStoreCategories: () => http('/store/categories').then((d) => d.categories || []),
  getStoreItems: (categoryId) => http(`/store/items${categoryId ? `?category_id=${categoryId}` : ''}`).then((d) => d.items || []),
  buyStoreItem: (id) => http('/store/buy', { method: 'POST', body: { id } }),
  getActivityLog: () => http('/activity').then((d) => d.items || []),
  getPointsHistory: () => http('/points-history').then((d) => d.items || []),
  getStorePurchasedItems: () => http('/store/purchased').then((d) => d.items || []),
  getStoreHistory: () => http('/store/history').then((d) => d.items || []),
  setNickname: (nickname) => http('/nickname', { method: 'POST', body: { nickname } }),
  changeNickname: (nickname) => http('/nickname', { method: 'POST', body: { nickname } }),
};

function vapi() {
  const vhttp = async (path) => {
    const res = await fetch(`/api/wowsmart/visitor${path}`);
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || 'Hazine hata');
    return data;
  };
  return {
    getUserProfile: () => vhttp('/catalog').then((d) => ({
      public_username: 'Misafir',
      nickname: 'Misafir',
      ach_points_balance: 0,
      ach_points_ever: 0,
      ach_gems_balance: 0,
      ach_diamonds_balance: 0,
      level: (d.levels || [])[0] || null,
      next_level: (d.levels || [])[1] || null,
      level_progress_pct: 0,
    })),
    getLevels: () => vhttp('/levels').then((d) => d.levels || []),
    getCurrentLevel: () => vhttp('/levels').then((d) => (d.levels || [])[0] || null),
    getMissions: () => vhttp('/missions').then((d) => d.missions || []),
    getStoreItems: () => vhttp('/store').then((d) => d.items || []),
    getStoreCategories: () => Promise.resolve([]),
    getLeaderBoard: (periodType = 'weekly', previous = false) =>
      vhttp(`/leaderboard?type=${encodeURIComponent(periodType)}${previous ? '&previous=1' : ''}`),
    getLeaderBoards: () => vhttp('/leaderboards').then((d) => d.leaderboards || []),
    getStorePurchasedItems: () => Promise.resolve([]),
    getStoreHistory: () => Promise.resolve([]),
    getActivityLog: () => Promise.resolve([]),
    getPointsHistory: () => Promise.resolve([]),
    getCatalog: () => vhttp('/catalog'),
  };
}

function createSdk(host) {
  return {
    init() { return this; },
    online() { emit('identify', {}); return this; },
    on(name, fn) {
      if (!listeners.has(name)) listeners.set(name, new Set());
      listeners.get(name).add(fn);
      return () => listeners.get(name)?.delete(fn);
    },
    dp(link) {
      const parsed = parseDp(link);
      if (typeof window !== 'undefined' && typeof window.__wowsmartDPCustom === 'function') {
        const handled = window.__wowsmartDPCustom(parsed);
        if (handled) return true;
      }
      host?.openFromDeepLink?.(parsed);
      return true;
    },
    api,
    vapi,
    showWidget() {},
    showBanner() {},
  };
}

let instance = null;

export function getWowSmart(host) {
  if (!instance) instance = createSdk(host);
  else if (host) instance = createSdk(host);
  if (typeof window !== 'undefined') window._wowsmart = instance;
  return instance;
}

export function bindWowSmartHash(openFn) {
  const run = () => {
    try {
      const hash = String(window.location.hash || '');
      const m = hash.match(/_wowsmart_dp=([^&]+)/);
      if (!m) return;
      const action = decodeURIComponent(m[1]);
      getWowSmart({ openFromDeepLink: openFn }).dp(action.startsWith('dp:') ? action : `dp:${action}`);
    } catch { /* ignore */ }
  };
  window.addEventListener('hashchange', run);
  run();
  return () => window.removeEventListener('hashchange', run);
}

export { parseDp, emit };
